import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/services/config.service';
import { RequestService } from '../../../../core/services/request.service';
import { ProductGroupDetails} from './details/product-group-details.model';

import { CatalogService } from '../catalogs/catalog.service';
@Injectable()
export class ProductGroupService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService,
        private catalogService: CatalogService
    ) { }

    edit(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.edit.api;
        return this.requestService.post(url, details);
    }

    add(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.add.api;
        return this.requestService.post(url, details);
    }

    delete(details: any): Observable<ProductGroupDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.delete.api;
        return this.requestService.post(url, details);
    }

    getProductGroupDetails(id: string): Observable<ProductGroupDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.details.api + '/' + id;
        return this.requestService.get(url);
    }

    getBrands(): Observable<ProductGroupDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.brands.api;
        return this.requestService.get(url);
    }

    getCategories(): Observable<ProductGroupDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.category.api;
        return this.requestService.get(url);
    }

    getSubtopics(categoryId: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.topics.listAvailableSubtopics.api + '/' + categoryId;
        return this.requestService.get(url);
    }
    getFilteredList(){
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productGroups.filteredList.api;
        return this.requestService.get(url);
    }
    getCategoryDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').productSeller.dictionary.category.api;
        return this.requestService.get(url);
    }

    getSellerDict(): Observable<any>{
        let url = this.configService.get('server').url + this.configService.get('endpoints').productSeller.dictionary.seller.api;
        return this.requestService.get(url);
    }
    
    getDetailsFields() {
        const categoryRoute = '/agora/product-data/categories/{{keyRoute}}/details';
        const fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'code',
                label: 'Code',
                type: 'text'
            }, {
                key: 'keywords',
                label: 'Keywords',
                type: 'list'
            }, {
                key: 'description',
                label: 'Description',
                type: 'text'
            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.domains && e.domains.length) e.domains.forEach(element => {
                        result.push(element.configValue);
                    });
                    return result;
                },
                label: 'Domains',
                type: 'list'
            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.categoryFamily && e.categoryFamily.length) e.categoryFamily.forEach(element => {
                        result.push(element.configValue);
                    });
                    return result;
                },
                label: 'Category Family',
                type: 'list'
            }, {
                id: 'ipStatement',
                key: 'ipStatement',
                label: 'IP Statement',
                type: 'html'
            }, {
                key: 'category.name',
                label: 'Category',
                type: 'link',
                config: {
                    route: categoryRoute,
                    keyRoute: 'category.id'
                }
            }, {
                key: (e: any) => {
                    let result;
                    let brand = e.brand;
                    if(brand && brand.image) {
                       result = '<li class="details-brand-element"><img src="'+
                           brand.image + '"/><span>'+ brand.name +'</span></li>';
                   } else if(brand && !brand.image) {
                       result = '<li class="details-brand-element"><span>'+ brand.name +'</span></li>';
                   } else {
                        result = null
                    }
                    return result;
                },
                label: 'Brand',
                type: 'innerHtml'
            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.subTopics && e.subTopics.length) e.subTopics.forEach(element => {
                        result.push(element.title);
                    });
                    return result;
                },
                label: 'Sub-topics',
                type: 'list'
            }
        ];
        return fields;
    };

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-groups/product-group.service.ts